import { FC } from "react";
import { useFormikContext } from "formik";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { Radio, RadioGroup } from "@design-system/Radio/Radio";
import { ClientFormSchema } from "../AddClientSteps/lib";
import styles from "./AddClientDrawerSteps.module.scss";

type MultiEntityValue = "yes" | "no" | "";

export const MultiEntityStep: FC = () => {
    const { values, setFieldValue, handleBlur } =
        useFormikContext<ClientFormSchema>();

    const handleSelect = (value: boolean) => {
        setFieldValue("isMultiEntity", value);
        handleBlur("isMultiEntity");

        if (value) {
            setFieldValue("plan.plan", FLAT_RATE_PLANS.PLUS);
            handleBlur("plan.plan");
        }
    };

    let selectedValue: MultiEntityValue = "";
    if (values.isMultiEntity !== null) {
        selectedValue = values.isMultiEntity ? "yes" : "no";
    }

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                Does this client have another entity?
            </div>
            <div className={styles.subheader}>
                Multi-entity clients keep separate books per entity but roll up
                into a single workspace. You can always add more entities later.
            </div>
            <RadioGroup<MultiEntityValue>
                name="isMultiEntity"
                aria-label="Client entity structure"
                value={selectedValue}
                onValueChange={(value) => {
                    if (value !== "") {
                        handleSelect(value === "yes");
                    }
                }}
                className={styles.multiEntityRadioGroup}
            >
                <Radio
                    className={styles.radio}
                    label={
                        <div className={styles.main}>
                            No, this is a single-entity client
                            <small className={styles.description}>
                                You can choose any plan.
                            </small>
                        </div>
                    }
                    value="no"
                />
                <Radio
                    className={styles.radio}
                    label={
                        <div className={styles.main}>
                            Yes, add another entity
                            <small className={styles.description}>
                                We&apos;ll set up the Chart of Accounts again
                                for the next entity. Multi-entity clients need
                                the Plus plan.
                            </small>
                        </div>
                    }
                    value="yes"
                />
            </RadioGroup>
        </div>
    );
};
